import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { withTranslation } from 'react-i18next'
import { removeContent } from '../../../../store/actions/blocks'
import { uploadToBlock } from '../../../../store/actions/upload'
import { setCropBlock } from '../../../../store/actions/selectedBlocks';

export const ImageBlockOptionsContainer = compose(
  connect(null, (dispatch, { block }) => ({
    upload: event => {
      dispatch(uploadToBlock(event.target.files, block))
      event.target.value = ''
    },
    removeContent: () => dispatch(removeContent([block])),
    crop: () => dispatch(setCropBlock(block.id))
  })),
  withProps(({ block }) => ({
    src: block.image.src,
    originalSource: block.image.originalLink || block.image.sourceUrl
  })),
  withTranslation()
)

export default ImageBlockOptionsContainer
